/*
 * @Author: liyxt
 * @Date: 2020-05-28 11:40:24
 * @LastEditors: bbqin
 * @LastEditTime: 2022-04-14 19:56:24
 * @Description: file content
 */
import React, { Component } from 'react';
//import OriginDropdown from 'bee-dropdown';
import { Dropdown as OriginDropdown } from '@tinper/next-ui';
import { getSysFieldid, microAppUtil } from '@platform/api';

//require('bee-dropdown/build/Dropdown.css');
require('./index.less');

class Dropdown extends Component {
	constructor(props) {
		super(props);
	}
	render() {
		let { overlayClassName, fieldid, getPopupContainer, ...others } = this.props;

		if (getSysFieldid(fieldid)) {
			if (overlayClassName) {
				overlayClassName = overlayClassName + ` fieldid_${fieldid}_btn_list`;
			} else {
				overlayClassName = `fieldid_${fieldid}_btn_list`;
			}
		}
		return (
			<OriginDropdown
				overlayClassName={`base-dropdown ${overlayClassName ? '' + overlayClassName : ''}`}
				getPopupContainer={ typeof getPopupContainer === "function" ? getPopupContainer : null }
				{...others}
			/>
		);
	}
}

Dropdown.Button = OriginDropdown.Button;
export default Dropdown;
